import { useState } from "react";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";
import { formatarTelefone } from "../utils/telefoneMask";
import { ChamadoFormData } from "../types/types";

interface UseChamadoFormParams {
  token: string | null;
  userEmail?: string;
  userId?: string | number;
}

const INITIAL_STATE: ChamadoFormData = {
  empresa: "",
  descricao: "",
  num_chamado: "",
  tipo_solicitacao: "",
  telefone: "",
};

export const useChamadoForm = ({
  token,
  userEmail,
  userId,
}: UseChamadoFormParams) => {
  const [formData, setFormData] = useState<ChamadoFormData>(INITIAL_STATE);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    // Tipamos o 'prev' para o TS saber exatamente a estrutura do estado anterior
    setFormData((prev: ChamadoFormData) => ({ ...prev, [e.target.id]: e.target.value }));
  };

  const handleChangeTipoSolicitacao = (tipo_solicitacao: string) => {
    setFormData((prev: ChamadoFormData) => ({ ...prev, tipo_solicitacao }));
  };

  const handleChangeTelefone = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData((prev: ChamadoFormData) => ({
      ...prev,
      telefone: formatarTelefone(e.target.value),
    }));
  };

  const handleKeyDownTelefone = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const { telefone } = formData;

    if (e.key !== "Backspace") return;

    if (telefone.length === 1) {
      setFormData((prev: ChamadoFormData) => ({ ...prev, telefone: "" }));
      return;
    }

    if (telefone.length >= 10 && telefone.endsWith("-")) {
      setFormData((prev: ChamadoFormData) => ({ ...prev, telefone: telefone.slice(0, -1) }));
    }
  };

  const resetForm = () => setFormData(INITIAL_STATE);

  const submitChamado = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const response = await fetch(`${process.env.REACT_APP_API}/api/Chamado`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          uuid: "",
          empresa: formData.empresa,
          num_Chamado: formData.num_chamado,
          email: userEmail,
          telefone: formData.telefone,
          HORARIO_CRIADO: new Date().toISOString(),
          tipoSolicitacao: formData.tipo_solicitacao,
          descricao: formData.descricao,
          id_usuario: userId,
        }),
      });

      const data = await response.json();

      if (response.ok) {
        toast.success("Chamado criado com sucesso!");
        resetForm();
        navigate("/chamados");
      } else {
        toast.error(data?.mensagem ?? "Não foi possível criar o chamado.");
      }
    } catch (error) {
      console.error(error);
      toast.error("Erro ao enviar chamado. Tente novamente.");
    } finally {
      setIsLoading(false);
    }
  };

  return {
    formData,
    isLoading,
    handleChange,
    handleChangeTipoSolicitacao,
    handleChangeTelefone,
    handleKeyDownTelefone,
    submitChamado,
  };
};